
document.addEventListener('DOMContentLoaded', function() {
    const faqQuestions = document.querySelectorAll('.faq-question');
    
    faqQuestions.forEach(question => {
      question.addEventListener('click', () => {
        const isExpanded = question.getAttribute('aria-expanded') === 'true';
        const answer = question.nextElementSibling;
        const plusIcon = question.querySelector('.plus-icon');
        
        // Close all other FAQs
        faqQuestions.forEach(q => {
          if (q !== question && q.getAttribute('aria-expanded') === 'true') {
            q.setAttribute('aria-expanded', 'false');
            q.nextElementSibling.style.maxHeight = '0';
            q.querySelector('.plus-icon').textContent = '+';
          }
        });
        
        // Toggle current FAQ
        question.setAttribute('aria-expanded', !isExpanded);
        plusIcon.textContent = isExpanded ? '+' : '−';
        
        if (!isExpanded) {
          answer.style.maxHeight = answer.scrollHeight + 'px';
        } else {
          answer.style.maxHeight = '0';
        }
      });
    });
  });